<template>
  <div>
    <div
      class="language-wrapper"
      @mouseenter="togglePanel(true)"
      @mouseleave="togglePanel(false)"
      :style="{ height: '60px' }"
    >
      <div class="languagebg" :class="{ dark: isDark }">
        <img
          class="language-img"
          :src="isDark ? languageDarkImg : languageImg"
        />
        <!-- <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M8.00001371,0 C12.4292114,0 16,3.57081173 16,8.00001933 C16,12.3243617 12.5320524,15.8870894 8.24900677,15.9973689 L7.9555807,16 C3.57894999,16 0,12.3929886 0,8.00001933 C0,3.5708251 3.57082378,0 8.00001371,0 Z M4.75194169,12.2043136 L4.68355213,12.2193119 C3.99067003,12.3754693 3.39854384,12.6075632 3.00466536,12.8805496 L2.92189224,12.9411142 L2.99410646,13.016747 C3.82290386,13.8557328 4.84423858,14.4719522 5.96132971,14.7974613 L6.21570003,14.8660759 L6.12985697,14.7732847 C5.56401091,14.1376403 5.11870835,13.3027697 4.79214689,12.3285316 L4.75194169,12.2043136 Z M11.2474572,12.2043136 L11.2066835,12.3331327 C10.8774571,13.3217831 10.4531711,14.1254982 9.8811433,14.7635616 L9.78510497,14.8653729 L9.79789899,14.8627389 C11.0089273,14.5588471 12.1179492,13.9156609 13.0059304,13.016748 L13.0775066,12.9411142 L12.9953626,12.8805476 C12.6014726,12.6075563 12.0093526,12.3754646 11.3164696,12.219311 L11.2474572,12.2043136 Z M7.54798728,11.8717691 L7.36491873,11.8739982 C6.82466302,11.8855524 6.28770377,11.9262521 5.78831185,11.9986966 L5.65255381,12.0201135 L5.67747388,12.0949492 C6.08367079,13.2983294 6.66135778,14.2043618 7.45010528,14.749126 L7.54798728,14.8126438 L7.54798728,11.8717691 Z M8.45141161,11.8724722 L8.45141161,14.8126438 L8.54803008,14.7505084 C9.33234034,14.2101115 9.91044954,13.3141841 10.3219316,12.1335489 L10.3447359,12.0629998 L10.2105265,12.0408084 C9.62075503,11.9474521 9.04829577,11.8890417 8.55222818,11.8742582 L8.45141161,11.8724722 Z M15.0854287,8.45141161 L11.8605202,8.45141161 L11.8442495,8.70533976 C11.7800525,9.58775269 11.689636,10.352634 11.5368868,11.1201637 L11.4949322,11.3149504 L11.5960654,11.3399932 C12.4341882,11.5553323 13.0832437,11.8142485 13.5452171,12.1474328 L13.6631506,12.2373572 L13.7312167,12.1499719 C14.4957413,11.1263775 14.9553059,9.90419479 15.0774427,8.57092728 L15.0854287,8.45141161 Z M4.13114505,8.45141161 L0.91326709,8.45141161 L0.92222425,8.56265008 C1.04352357,9.8575756 1.51396725,11.0866036 2.27233481,12.145216 L2.33906051,12.235248 L2.45479492,12.1474382 C2.91675599,11.8142614 3.56580776,11.5553467 4.40393163,11.3399969 L4.49954532,11.3156534 L4.45621542,11.1364525 C4.26088783,10.2812688 4.15467869,9.3749307 4.13348811,8.59643371 L4.13114505,8.45141161 Z M10.9655326,8.45141161 L8.45141161,8.45141161 L8.45141161,10.9690478 L8.53540791,10.9706654 C9.07814803,10.9848379 9.74693451,11.0477168 10.4348438,11.1467394 L10.6013506,11.1715274 L10.6355236,11.0306143 C10.8373892,10.1426845 10.9467315,9.23358026 10.9649436,8.51912183 L10.9655326,8.45141161 Z M7.54798728,8.45141161 L5.04159992,8.45141161 L5.06950408,8.86013696 C5.0875856,9.11491831 5.10696186,9.34184688 5.1315098,9.57259368 C5.18299805,10.0565751 5.25349107,10.5162565 5.35023042,10.96317 L5.39804828,11.1687152 L5.61865634,11.1301081 C6.20658655,11.0357546 6.78729527,10.9858111 7.35220918,10.9717842 L7.54798728,10.9690478 L7.54798728,8.45141161 Z M5.39664217,4.91505021 L5.35217848,5.09165888 C5.1626908,5.89011407 5.05739599,6.74140668 5.0363365,7.43633797 L5.03386633,7.54798728 L7.54798728,7.54798728 L7.54798728,5.07464346 L7.36304556,5.07316926 C6.8081401,5.06108628 6.20156079,5.01872402 5.61760985,4.94536438 L5.39664217,4.91505021 Z M10.6013506,4.87216392 L10.4290962,4.89873964 C9.7336031,4.99963741 9.094505,5.06028488 8.54215546,5.07387021 L8.45141161,5.07464346 L8.45141161,7.54798728 L10.9570959,7.54798728 L10.9305431,7.14067946 C10.9124732,6.88699358 10.8930884,6.66150812 10.868533,6.43318523 C10.817092,5.9548721 10.7466528,5.50433723 10.650003,5.07120195 L10.6013506,4.87216392 Z M2.29476811,3.76485394 L2.23037156,3.85208468 C1.48532792,4.89771614 1.04473404,6.12444154 0.959506535,7.43089204 L0.953341165,7.54798728 L4.17543745,7.54798728 L4.17754147,7.41858153 C4.19686183,6.67695578 4.2933252,5.78303576 4.46471723,4.91767065 L4.50376365,4.73014702 L4.41269586,4.70839726 C3.59601311,4.5027673 2.9092961,4.21644749 2.42234052,3.86281123 L2.29476811,3.76485394 Z M13.7046308,3.76485394 L13.5777082,3.86280981 C13.0947744,4.21352138 12.4153522,4.49802726 11.6075315,4.70328184 L11.4998536,4.72874091 L11.5441112,4.90840992 C11.7401224,5.76173863 11.8455857,6.6442154 11.866602,7.40844416 L11.8682538,7.54798728 L15.0861318,7.54798728 L15.0777061,7.43193619 C14.9573433,6.11165068 14.506636,4.88550723 13.7681448,3.84994354 L13.7046308,3.76485394 Z M8.45141161,1.18745813 L8.45141161,4.17192218 L8.63503831,4.17046519 C9.17520516,4.15890685 9.7122105,4.11819451 10.2116744,4.04574681 L10.346142,4.02357779 L10.3212937,3.94525993 C9.90873441,2.71955849 9.33038725,1.7955928 8.54744129,1.25027336 L8.45141161,1.18745813 Z M7.54798728,1.19448867 L7.44399413,1.26648153 C6.63206979,1.85543724 6.02914668,2.79624487 5.67258396,3.94238954 L5.65044465,4.01654725 L6.46088678,4.10400711 L6.77678009,4.13237514 L7.06174125,4.15310602 L7.32344685,4.16656572 C7.36555296,4.1682234 7.40700995,4.16959337 7.44797774,4.17068324 L7.54798728,4.17192218 L7.54798728,1.19448867 Z M6.21429392,1.13402603 L6.20017553,1.13783207 C4.98474096,1.44346977 3.87351448,2.09278059 2.95584971,3.02154922 L2.87759984,3.10257711 L2.9544532,3.16001108 C3.33703796,3.42768071 3.91681638,3.66541822 4.63716807,3.85977702 L4.70835235,3.87804562 L4.74659191,3.75524212 C5.07068298,2.75619442 5.5190983,1.90979471 6.1080822,1.24899411 L6.21429392,1.13402603 Z M9.78510497,1.13402603 L9.88844535,1.24476657 C10.4698508,1.89464097 10.9170848,2.72405617 11.2449915,3.69428226 L11.2917496,3.83937766 L11.360903,3.82513926 C12.0538051,3.66895633 12.6459257,3.43685327 13.0397542,3.16387081 L13.121799,3.10257711 L13.044151,3.02154752 C12.1877137,2.15470259 11.1626209,1.53128892 10.0415373,1.20352378 L9.78510497,1.13402603 Z"
            id="lang"
            :fill="isDark ? '#fff' : '#000'"
          ></path>
        </svg> -->
        <div
          class="selectedLanguage"
          :class="{ dark: isDark, hint: showPanel }"
          :style="{
            marginLeft: '6px',
          }"
        >
          {{ currentLanguageTitle }}
          <div v-if="showPanel" class="language-panel">
            <div
              class="languagein"
              v-for="language in languages"
              :key="language.lang"
              @click="changeLanguage(language)"
            >
              {{ language.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isDark", "isFirst"],
  data() {
    return {
      showPanel: false,
      currentLanguage: this.$i18n.locale,
      // buttonText: this.$i18n.locale,
      languages: [
        { title: "简体中文", lang: "zh" },
        { title: "English", lang: "en" },
      ],
      languageImg: require(`../assets/language.png`),
      languageDarkImg: require(`../assets/language_light.png`),
    };
  },
  computed: {
    currentLanguageTitle() {
      const language = this.languages.find(
        (lang) => lang.lang === this.currentLanguage
      );
      return language ? language.title : "";
    },
  },
  methods: {
    togglePanel(bool) {
      this.showPanel = bool;
    },
    changeLanguage(language) {
      // this.$emit('changeLanguage',lang)
      this.currentLanguage = language.lang;
      // this.buttonText = language.title;
      this.showPanel = false;
      this.$i18n.locale = language.lang;
    },
  },
};
</script>

<style lang="scss" scoped>
.selectedLanguage {
  position: relative;
  color: #101010;
  font-size: 0.15rem;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    color: #2980fe;
  }
  &.dark {
    color: #fff;
    &:hover {
      color: #2980fe;
    }
  }
}
.languagebg {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 8px;
  border-radius: 15px;
  &.dark {
    // background: #38547d;
  }
}
.hint {
  color: #2980fe;
}
.language-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-left: 10px;
  .language-img {
    margin-right: 10px;
    width: 0.24rem;
    height: 0.24rem;
  }
}
.language-panel {
  position: absolute;
  z-index: 999;
  min-width: 90px;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px;
  background: #fff;
  transition: all 0.3s linear;
  z-index: 10;
  border: 1px solid #f1f3f5;
  border-radius: 16px 20px;
  box-shadow: 0 6px 16px 0 rgba(45, 54, 86, 0.05);
  .languagein {
    position: relative;
    height: 40px;
    line-height: 40px;
    color: #101010;
    cursor: pointer;
    &:hover {
      color: #2980fe;
    }
  }

  @media screen and (max-width: 767px) {
    .language-img {
      margin-right: 10px;
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}
</style>
